import React from "react";

const Footer = () => {
  const footerStyle = {
    padding: "1.2rem 0",
    background: "#f9fafb",
    borderTop: "1px solid rgba(229, 231, 235, 0.8)",
    textAlign: "center",
    fontSize: "0.9rem",
    color: "#4b5563",
  };

  const boldStyle = {
    fontWeight: 700,
    color: "#116530",
  };

  return (
    <footer style={footerStyle}>
      © <span style={boldStyle}>EcoPro Earth Private Limited 2025–2026</span> | All Rights Reserved.
    </footer>
  );
};

export default Footer;
